const trans_ar_EG = {
  // Form Fields
  name: "الاسم",
  first_name: "الاسم الأول",
  last_name: "اسم العائلة",
  name_ar: "الاسم باللغة العربية",
  name_en: "الاسم باللغة الإنجليزية",
  price: "السعر",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  confirm_password: "تأكيد كلمة المرور",
  phone_number: "رقم الهاتف",
  business_name: "اسم النشاط التجاري",
  business_type: "نوع النشاط التجاري",
  shop_address: "عنوان المتجر",
  cr_number: "رقم السجل التجاري",
  vat_number: "رقم ضريبة القيمة المضافة",
  business_logo: "شعار النشاط التجاري",
  image: "الصورة",
  is_taxable: "خاضع للضريبة",
  is_refunded: "تم الاسترداد",
  is_QRproduct: "منتج برمز QR",
  is_stockable: "قابل للتخزين",
  reset: "إعادة تعيين",
  cart: "سلة التسوق",
  address: "العنوان",
  company: "شركة",
  code: "الرمز",
  branch: "الفرع",
  active: "نشط",
  inactive: "غير نشط",
  no_of_employees: "عدد الموظفين",
  no_of_licenses: "عدد التراخيص",
  vat_certificate: "شهادة ضريبة القيمة المضافة",
  cr_certificate: "شهادة السجل التجاري",
  change: "تغيير",
  preview: "معاينة",

  // Form Validations
  validate_email_required: "حقل البريد الإلكتروني مطلوب.",
  validate_email_invalid: "الإدخال ليس بريدًا إلكترونيًا صالحًا!",
  validate_password_required: "حقل كلمة المرور مطلوب.",
  validate_password_min_characters:
    "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
  validate_password_confirm_not_matched: "تأكيد كلمة المرور غير مطابق.",
  validate_first_name_required: "حقل الاسم الأول مطلوب.",
  validate_first_name_min_characters:
    "يجب أن يتكون الاسم الأول من 3 أحرف على الأقل.",
  validate_last_name_required: "حقل اسم العائلة مطلوب.",
  validate_last_name_min_characters:
    "يجب أن يتكون اسم العائلة من 3 أحرف على الأقل.",
  validate_phone_required: "حقل رقم الهاتف مطلوب.",
  validate_phone_exact_limit: "يجب أن يكون الرقم مكونًا من 12 رقمًا بالضبط.",
  validate_image_file_type: "يمكنك تحميل ملفات JPG أو PNG فقط!",
  validate_image_size_2: "يجب أن تكون الصورة أقل من 2 ميجابايت!",
  validate_file_size_5: "يجب أن تكون الصورة أقل من 5 ميجابايت!",

  // Login
  dont_have_account: "ليس لديك حساب؟",
  login: "تسجيل الدخول",
  visit_website: "زيارة الموقع",

  // Register
  already_have_an_account: "هل لديك حساب بالفعل؟",
  sign_up: "إنشاء حساب",

  // Forgot
  forgot_password: "نسيت كلمة المرور",
  send_otp: "إرسال رمز التحقق",
  verify_otp: "تحقق من الرمز",
  reset_password: "إعادة تعيين كلمة المرور",
  reset_password_successfully: "تمت إعادة تعيين كلمة المرور بنجاح!",

  // OTP form
  opt_message:
    "تم إرسال رمز التحقق إلى رقم هاتفك. يرجى تعبئة الحقل أدناه والتحقق.",
  if_you_want_to_change_phone_number: "إذا كنت ترغب في تغيير رقم الهاتف",
  click_here: "اضغط هنا.",
  resend_code: "إعادة إرسال الرمز",
  enable_in: "التفعيل خلال",
  validate: "تحقق",

  // Menus
  home: "الرئيسية",
  companies: "شركات",
  help_desk: "الدعم الفني",
  profile: "الملف الشخصي",
  commission: "عمولة",
  payout_detail: "تفاصيل الدفع",

  // Table Columns
  action: "إجراء",
  type: "النوع",
  status: "الحالة",
  date: "التاريخ",
  description: "الوصف",
  attachment: "المرفق",
  customer_name: "اسم العميل",
  contact: "اتصل",
  assigned_to: "مُعيّن إليه",

  // Warnings
  warning_delete: "هل أنت متأكد من حذف هذا الكيان؟",

  // Miscellaneous
  yes: "نعم",
  no: "لا",
  logout: "تسجيل الخروج",
  submit: "إرسال",
  search: "بحث",
  upload: "رفع",
  something_went_wrong: "حدث خطأ ما",
  reference_no: "رقم المرجع",
  total_amount: "المبلغ الإجمالي",
  rejected: "مرفوض",
  individual: "فرد",
  photo_of_id: "صورة الهوية",
  validate_photo_of_id_required: "مطلوب تقديم صورة الهوية",
  company_name: "اسم الشركة",
  validate_type_required: "حقل النوع مطلوب.",
  validate_company_name_required: "حقل اسم الشركة مطلوب.",
  company_registration_document: "وثيقة تسجيل الشركة",
  validate_company_registration_document_required:
    "حقل وثيقة تسجيل الشركة مطلوب.",
  wallet_detail: "تفاصيل المحفظة",
  bank_detail: "تفاصيل البنك",
  payout_history: "تاريخ الدفع",
  available_balance: "الرصيد المتاح",
  level_config: "تكوين المستوى",
  account_title: "اسم الحساب",
  bank_name: "اسم البنك",
  account_number: "رقم الحساب",
  branch_code: "رمز الفرع",
  city: "المدينة",
  country: "الدولة",
  reseller_number: "رقم الموزع",
  target: "الهدف",
  retain_rate: "نسبة الاحتفاظ",
  total: "الإجمالي",
  balance_details: "تفاصيل الرصيد",
  reference_number: "رقم المرجع",
  add_company: "إضافة شركة",
  portal_url_not_configured: "عنوان URL للبوابة غير مهيأ.",
  forward_to_csr: "تمرير إلى موظف الخدمات العملائية",
  mark_new: "وسم كجديد",
  mark_inprogress: "وضع علامة قيد التقدم",
  mark_done: "وسم كمكتمل",
  mark_closed: "وسم كمغلق",
  amount: "المبلغ",
  kyc: "KYC",
  in_review: "قيد المراجعة",
  new_tickets: "تذاكر جديدة",
  inprogress_tickets: "تذاكر قيد الإنجاز",
  done_tickets: "التذاكر تمت",
  closed_tickets: "تذاكر مغلقة",
  late_tickets: "التذاكر المتأخرة",
  delayed_tickets: "التذاكر المؤجلة",
  ticket_updated: "تم تحديث التذكرة",
  ticket_updated_successfully: "تم تحديث التذكرة بنجاح!",
  status_updated_successfully: "تم تحديث الحالة بنجاح!",
  hi: "مرحبًا",
  thankyou_for_applying_account: "شكرا لتقديمك طلب لفتح حساب!",
  account_pending_message: "حسابك قيد المراجعة حاليا من قبل مسؤول الموقع.",
  account_rejection: "للأسف، تم رفض طلب فتح حسابك!",
  account_under_review: "حسابك قيد المراجعة!",
  account_under_review_details:
    "عادة ما يستغرق ذلك يوماً واحدا. حتى تم المراجعة، لن يمكنك القيام بأي شيء",
  account_blocked: "تم حظر حسابك!",
  kindly_contact_at: "يرجى التواصل معنا على contact@anypos.ai",
  basic_level: "المستوى الأساسي",
  pro_level: "المستوى المحترف",

  partner_rank: "تصنيف الشريك",
  unpaid_comission: "عمولة غير مدفوعة",
  paid_comission: "عمولة مدفوعة",
  active_customers: "العملاء النشطين",
  inactive_customers: "العملاء غير النشطين",
  monthly_new_customers: "العملاء الجدد شهريًا",
  monthly_inactive_customers: "العملاء غير النشطين شهريًا",
  submitting_kyc: "أرسل اعرف عميلك",
  idle_customers: "العملاء الخاملون",
  owner: "المالك",
  csr: "ممثل خدمة العملاء",
};

export default trans_ar_EG;
